import { Icon, IconProps, type SxProps } from "@mui/material";
import { forwardRef } from "react";

const MaterialSymbols = {
  Bolt: "bolt",
  Gavel: "gavel",
  Target: "target",
  QuickPhrases: "quick_phrases",
} as const;

type MaterialSymbolName = (typeof MaterialSymbols)[keyof typeof MaterialSymbols];

interface IProps extends Omit<IconProps, "children" | "baseClassName"> {
  symbol: MaterialSymbolName;
  size?: number | string;
  sx?: SxProps;
}

const MaterialSymbolIcon = forwardRef<HTMLSpanElement, IProps>(({ symbol, size: sizeProp, sx, ...iconProps }, ref) => {
  const size = sizeProp ?? 18;

  return (
    <Icon
      ref={ref}
      baseClassName="material-symbols-outlined"
      sx={{
        fontSize: size,
        ...sx,
      }}
      {...iconProps}
    >
      {symbol}
    </Icon>
  );
});

export { MaterialSymbolIcon, MaterialSymbols };
